import styled from "styled-components";
import { Colors } from "../../constants/Colors";

export const SalesOptionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${Colors.commons.white};
  border-radius: 10px;
  padding: 10px;
  padding-left: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 450px;
  min-width: 260px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    max-width: 100%;
    min-width: 0;
    padding: 10px 12px;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  flex-grow: 1;
  padding-right: 15px;
  color: ${Colors.primary[100]};
  font-weight: bold;
  font-size: 20px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 24px;
  color: ${Colors.secondary[100]};

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const QuantityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${Colors.commons.white};
  border-radius: 10px;
  padding: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  min-width: 60px;

  span {
    font-size: 18px;
    color: ${Colors.commons.black};
    margin: 5px 0;
  }

  @media (max-width: 768px) {
    min-width: 56px;
  }
`;

export const QuantityButton = styled.button`
  background: none;
  border: none;
  color: ${Colors.primary[100]};
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;

  &:focus {
    outline: none;
  }
`;
